import * as React from 'react';
import Base, { Props as BaseProps, TypeColors } from '../Base/Base';

export interface Props extends BaseProps {
  /**
   * Background color of the box. Any valid palette color
   * can be used.
   */
  backgroundColor?: TypeColors;
}

/**
 * A simple shpare component that can be used to create
 * placeholder content for the skeleton loading pattern.
 */
const SkeletonBox: React.FunctionComponent<Props> = (props: Props) => {
  const { backgroundColor, ...rest } = props;

  return (
    <Base { ...rest }
        backgroundColor={ backgroundColor } />
  );
};

SkeletonBox.defaultProps = {
  backgroundColor: 'gray-2',
};

export default SkeletonBox;
